var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-image",style:({ backgroundImage: ("url('" + _vm.default_thumbnail + "')") })},[_c('img',{class:{ loaded: _vm.loaded },attrs:{"src":_vm.src},on:{"error":_vm.onError,"load":_vm.onLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }